import { render, staticRenderFns } from "./EditarDadosPaciente.vue?vue&type=template&id=b9a184e2&"
import script from "./EditarDadosPaciente.vue?vue&type=script&lang=js&"
export * from "./EditarDadosPaciente.vue?vue&type=script&lang=js&"
import style0 from "./EditarDadosPaciente.vue?vue&type=style&index=0&id=b9a184e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports